import * as React from 'react';
import { TableFavouriteModelComponent } from '../table-favourite-model-component';
import { FavouriteRow } from '../types';

import styles from './footer.scss';

export const renderTableFooter = (model: TableFavouriteModelComponent, row: FavouriteRow,
  hideAggregateColumns: boolean, onClick: () => void) => {

  const { dataModel: { columns }, dataAdapter: { aggrColIndex } } = model;
  const total = model.getFooterColumnTextAndValue(columns[aggrColIndex].aggregationType);
  const tooltip = model.getTooltip(aggrColIndex);

  if (aggrColIndex < 0) {
    return false;
  }

  return <tr className={`${styles.footerRowStyle} ${styles.footerRow}`} >
    {aggrColIndex > 0 && <td colSpan={1} />}
    <td onClick={onClick} 
      colSpan={aggrColIndex}
      title={tooltip}
      className={`aggregation ${styles.total}`}>
      <span className={styles.totalText}>
        {total.label}
      </span>
      <span className={styles.totalValue}>
        {total.value}
      </span>
    </td>
    {!hideAggregateColumns && !!row.rollingAvarage && <td colSpan={1} />}
    {!hideAggregateColumns && !!row.target && <td colSpan={1} />}
  </tr>;
};
